import { Injectable } from '@angular/core';
import { Subject, Subscription, switchMap, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PluginInitializerService {
  initializePlugin: Subject<string> = new Subject();
  private plugins: string[] = [];
  private first = false;
  private subs: Subscription[] = [];

  register(plugin: string) {
    this.plugins.push(plugin);
    if (this.plugins.length === 1 && !this.first) {
      this.first = true;
      this.next();
    }
  }

  next() {
    if (this.plugins.length) {
      const p = this.plugins.splice(0,1)[0];
      this.initializePlugin.next(p);
    }
  }

  setup(pluginName: string, initFunc: () => Promise<void>, resolve: (value: void) => void) {
    this.subs.push(
      this.initializePlugin.pipe(
        take(this.plugins.length + 1),
        switchMap( async (plugin: string) => {
          if (plugin === pluginName) {
            await initFunc();
            this.next();
            resolve();
          }
        }),
      ).subscribe()
    )
    this.register(pluginName);
  }
}
